import React, { useState, useRef, useEffect } from "react";
import './multi-select-dropdown.css'
import { Button } from "react-bootstrap";

const MultiSelectDropdown = (props) => {
  const [val, setVal] = useState("");
  const [selectedOptions, setSelectedOptions] = useState(["All"]);
  const [selectedIDs, setSelectedIDs] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const dropdownRef = useRef(null);
  const [data, setData] = useState([
    {
      Id: "All",
      value: "All",
      isSelected: true
    },
    {
      Id: "10-30",
      value: "10% to 30%",
      isSelected: false
    },
    {
      Id: "31-50",
      value: "31% to 50%",
      isSelected: false
    },
    {
      Id: "51-70",
      value: "51% to 70%",
      isSelected: false
    },
    {
      Id: "71-90",
      value: "71% to 90%",
      isSelected: false
    },
    {
      Id: "91-100",
      value: "91% to 100%",
      isSelected: false
    },
  ]);

  const handleOptionClick = (option) => {
    if (option === "All") {
     // const allSelected = data.every((item) => item.isSelected);
      const updatedOptions = data.map((item) =>
        item.value === option
          ? { ...item, isSelected: true }
          : { ...item, isSelected: false }
   
      );
      setData(updatedOptions);
    } else {
      const updatedOptions = data.map((item) =>
        item.value === option
          ? { ...item, isSelected: !item.isSelected }
          : item.value === "All" && item.isSelected
            ? { ...item, isSelected: false }
            : item
      );
      setData(updatedOptions);
    }
  };
  // const handleDropdownClick = () => {

  //   isDropdownOpen ? setIsDropdownOpen(true) : setIsDropdownOpen(false)
  // };

  const handleOkClick = () => {
    setIsDropdownOpen(false)
    setIsToggled(false)
    const selectedValues = data
      .filter((item) => item.isSelected)
      .map((item) => item.value);
    setSelectedOptions(selectedValues);

    const selectedId = data
      .filter((item) => item.isSelected)
      .map((item) => item.Id);
    setSelectedIDs(selectedId);
    props.datachnages(selectedId, 'solution coverage')

  };

  const handleCancelClick = () => {
    setIsDropdownOpen(false);
    setIsToggled(false)
  };

  const handleSelectProductClick = () => {
    setIsDropdownOpen(!isDropdownOpen)
    setIsToggled(!isToggled);
  };


  return (
    <div className="main">
      <button onClick={handleSelectProductClick} className="multi-select-button d-flex justify-content-between">
        <span className="text-body font-size-14">{selectedOptions.includes("All") ? 'All' :'Select'}</span>
        <div>
          <svg
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          // className={isToggled ? 'rotated' : ''}
          >
            <path d="M2 0L7 5L12 0L14 1L7 8L0 1L2 0Z" fill="#5E6C84" />
          </svg>
        </div>

      </button>

      {/* {isDropdownOpen && ( */}
      <>
        <div className={`dropdown multi-select-dropdown ${isDropdownOpen ? "is-click" : "is-not-click"}`} ref={dropdownRef}>
          <div className=" product-options">
            {data
              .filter((item) =>
                val
                  ? item.value.toLowerCase().includes(val.toLowerCase())
                  : true
              )
              .map((item) => (
                <div
                  key={item.Id}
                  onClick={() => handleOptionClick(item.value)}
                  className="d-flex"
                >
                  <input type="checkbox" className="my-custom-checkbox" checked={item.isSelected} readOnly />
                  <label className="ml-2 text-dark-grey">{item.value}</label>
                </div>
              ))}

          </div>
          <div className="multi-select-submit">
            <Button onClick={handleOkClick} className="mr-2 w-100 border-0 bg-primary text-white font-weight-bold button">
              OK
            </Button>
            <Button onClick={handleCancelClick} className="mr-2 w-100 border-0 bg-danger text-white font-weight-bold button">
              Cancel
            </Button>
          </div>
        </div>
      </>
      {/* )} */}

      {!isDropdownOpen && (
        <div className="show-product-list">
          <ul>
            {selectedOptions.map((option) => (
              <li key={option}>{option}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default MultiSelectDropdown;
